import clsx from 'clsx'
import { flexRender, Row, Table } from '@tanstack/react-table'

import { TableCell, TableRow } from '@/ui/Table'
import { UpdatedLog } from '@/types/logs'

import styles from './UpdatedRecordsTable.module.scss'
import { Code } from '@/modules/CombinedLogs/ui/components/information/Code'
import { useCachedGetCodeName } from '@/modules/CombinedLogs/hooks/useCachedGetCodeName'

interface Props {
    row: Row<UpdatedLog>
    table: Table<UpdatedLog>
}

export const UpdatedRecordRow = ({ row }: Props) => {
    const getCodeName = useCachedGetCodeName()

    const needToDisplaySeparator = !!row.index && !!row.original.unfinishedType
    const isPrimaryRow =
        (!row.original.unfinishedType && !!row.original.groupId) ||
        (!!row.original.unfinishedType && !row.original.groupId)

    return (
        <>
            {needToDisplaySeparator && (
                <tr className={styles.separator}>
                    <td></td>
                </tr>
            )}
            <TableRow
                className={clsx({ [styles.primaryRow]: isPrimaryRow, [styles.secondaryRow]: !isPrimaryRow })}
                key={row.id}
            >
                {row.getVisibleCells().map((cell) => {
                    const cellContent =
                        cell.column.id === 'code' ? (
                            <Code {...cell} getCodeName={getCodeName} />
                        ) : (
                            flexRender(cell.column.columnDef.cell, cell.getContext())
                        )

                    return (
                        <TableCell key={cell.id} alignCenter={cell.column.columnDef.meta?.alignCenter}>
                            {cellContent}
                        </TableCell>
                    )
                })}
            </TableRow>
        </>
    )
}
